import React from "react";
import "./collections-overview.styles.scss";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import CollectionPreview from "../collection-preview/collection-preview.component";
import { selectCollections, selectCollectionsForPreview } from '../../redux/shop/shop.selector';


const CollectionsOverview=({collections})=>(
    <div className="collections-overview">
        {collections.map(({ id, ...otherCollectionProps }) => {
        return <CollectionPreview key={id} {...otherCollectionProps} />;
      })}
    </div>
)

const mapStateToProps=createStructuredSelector({
    collections:selectCollectionsForPreview
  })

export default connect(mapStateToProps)(CollectionsOverview);